import { Group } from '@/icons'
import { Badge } from '@chakra-ui/react'
import type { OrganizationUnitType } from 'BrokerTsLib/src/enums'
import { getOrganizationUnitTypeName } from 'BrokerTsLib/src/enums'

export const OrganizationTypeBadge = ({ type }: { type: OrganizationUnitType }) =>
  <Badge colorScheme="blue" width={'fit-content'} gap={1} display={'flex'} alignItems={'center'} fontWeight={'medium'} h={'20px'}><Group boxSize={4} /> {getOrganizationUnitTypeName(type)}</Badge>